import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Check, ArrowRight, CalendarCheck, Mail } from 'lucide-react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { CONTACT } from '@/data/contact';

const NEXT = [
  'Your submission is with our strategy desk and under review now.',
  'You will receive your written Meta Ads breakdown by email, sent to the address you provided.',
  'If it looks like a strong fit, an account lead will propose a short call to walk you through the findings.',
];

export default function ThankYou() {
  return (
    <div className="min-h-screen bg-[#0B0B0B] flex flex-col">
      <Navbar />
      <main className="flex-1 relative overflow-hidden pt-36 pb-24">
        <div className="absolute inset-0 fine-grid opacity-70" />
        <div className="absolute -top-40 left-1/3 w-[560px] h-[560px] bg-[#2563EB]/15 blur-[160px] rounded-full" />

        <div className="relative max-w-[820px] mx-auto px-6 lg:px-10 text-center">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6 }}
            className="mx-auto w-16 h-16 rounded-full bg-[#2563EB] flex items-center justify-center blue-glow"
          >
            <Check className="w-8 h-8 text-white" />
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="mt-9 font-display font-bold text-white tracking-tight text-4xl lg:text-6xl leading-[1.05]"
          >
            Thank You — <span className="text-[#3B82F6]">Your Breakdown Is Being Prepared</span>
          </motion.h1>

          <p className="mt-7 text-lg text-white/60 font-light leading-relaxed">
            We have received your details. Here is precisely what happens next.
          </p>

          <ul className="mt-10 text-left space-y-4 max-w-xl mx-auto">
            {NEXT.map((n) => (
              <li key={n} className="flex gap-3 items-start rounded-lg border border-white/10 bg-white/[0.03] p-5">
                <Check className="w-4 h-4 text-[#3B82F6] mt-1 shrink-0" />
                <span className="text-white/65 font-light leading-relaxed text-sm">{n}</span>
              </li>
            ))}
          </ul>

          <div className="mt-11 flex flex-col sm:flex-row gap-3 justify-center">
            <a
              href={CONTACT.calendly}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 px-8 h-14 rounded-lg bg-[#2563EB] text-white text-sm font-bold hover:bg-[#1D4ED8] transition-colors"
            >
              <CalendarCheck className="w-4 h-4" /> Book your call now
            </a>
            <Link
              to="/"
              className="group inline-flex items-center justify-center gap-2 px-8 h-14 rounded-lg border border-white/20 text-white text-sm font-semibold hover:border-[#3B82F6] transition-colors"
            >
              Explore the agency
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>

          <a
            href={`mailto:${CONTACT.sales}`}
            className="mt-9 inline-flex items-center gap-2 text-sm text-white/45 hover:text-[#3B82F6] transition-colors"
          >
            <Mail className="w-4 h-4" /> {CONTACT.sales}
          </a>
        </div>
      </main>
      <Footer />
    </div>
  );
}